// src/constants.ts

export const DROPDOWNTYPES = {
  CHOOSE_PROFILE: "choose_profile",
  INTERESTED_IN: "interested_in",
  BUSINESS_INDUSTRY: "business_industry",
  BUSINESS_LOCATION: "business_location",
  NO_OF_EMPLOYEES: "no_of_employees",
  BUSINESS_ENTITY_TYPE: "business_entity_type",
  DOCUMENTS: "documents",
  BUSINESS_TYPE: "business_type",
  BUSINESS_SIZE: "business_size",
  LANGUAGE_PREFERENCES: "language_preferences",
  PREFERRED_NETWORK_REGION: "preferred_network_region",
  CHALLENGE_IDENTIFICATIONS: "challenge_identifications",
  ADDRESS_CHALLENGES: "address_challenges",
  RATE_EFFECTIVENESS: "rate_effectiveness",
  RESOURCE_BENEFICIAL: "resource_beneficial",
  PREVIOUS_COLLABORATION: "previous_collaboration",
  DESIRED_NETWORK_OUTCOME: "desired_network_outcome",
  PREFERRED_NETWORK_FORMAT: "preferred_network_format",
  PRIORITY_LEVEL: "priority_level",
} as const;

export const ACCOUNT_TYPE = {
  'WANT-TO-GROW': "WANT_TO_GROW",
  'WANT-TO-SELL': "WANT_TO_SELL",
  'INVESTMENT': "INVESTMENT",
} as const;
export const ACCOUNT_TYPE_API = {
  'WANT_TO_GROW': "want-to-grow",
  'WANT_TO_SELL': "want-to-sell",
  'INVESTMENT': "investment",
} as const;

export const LOGIN_TYPE = {
  ENTREPRENEUR: "ENTREPRENEUR",
  INVESTOR: "INVESTOR",
} as const;

export const DOCUMENT_TYPE = {
  BUSINES_PHOTO: "BUSINESS_PHOTO",
  VALUATION_REPORT: "VALUATION_REPORT",
  PITCH_DECK: "PITCH_DECK"
}
export const NAVIGATION_CONST = {
  LOGIN: "LOGIN",
  REGISTRATION: "REGISTRATION"
}
export const MENU = {
  DASHBOARD: "DASHBOARD",
  MANAGE_ROLE: "MANAGE_ROLE",
  MANAGE_USER: "MANAGE_USER",
  MANAGE_BANNER: "MANAGE_BANNER",
  MANAGE_SUBSCRIPTION: "MANAGE_SUBSCRIPTION",
    MANAGE_COUPONS: "MANAGE_COUPONS",
  MANAGE_INVESTOR: "MANAGE_INVESTOR",
  MANAGE_ENTERPRENEUR: "MANAGE_ENTERPRENEUR",
  MANAGE_MENTOR:"MANAGE_MENTOR",
  MENTOR_PAYMENTS: "MENTOR_PAYMENTS",
  MANAGE_NOTIFICATION: "MANAGE_NOTFICATION",
  MANAGE_CMS: "MANAGE_CMS",
  MANAGE_BLOGS: "MANAGE_BLOGS",
  MANAGE_TRANSACTION: "MANAGE_TRANSACTION",
  MANAGE_ACTIVE_SUBSCRIPTION: "MANAGE_ACTIVE_SUBSCRIPTION",
  MANAGE_CUSTOMER_QUERIES: " MANAGE_CUSTOMER_QUERIES",
  MANAGE_DEACTIVATED_ACCOUNTS:"MANAGE_DEACTIVATED_ACCOUNTS",
  MANAGE_EMAIL:"MANAGE_EMAIL",
  MANAGE_PROMOTION:"MANAGE_PROMOTION",
  INVESTOR_FORUM_POST:"INVESTOR_FORUM_POST",
  MANAGE_SESSIONS:"MANAGE_SESSIONS"
}
